

import { includesValidator } from '../../common/utils/validator';

const FontStyles = {
  Normal: 'normal',
  Italic: 'italic',
};

export default {
  name: 'BbCustomInput',
  props: {
    fontFamily: String,
    fontWeight: [String, Number],
    fontSize: Number,
    fontStyle: {
      type: String,
      default: FontStyles.Normal,
      validator: includesValidator(FontStyles),
    },
    lineHeight: Number,
    letterSpacing: Number,
    text: String,
    color: String,
    readOnly: {
      type: Boolean,
      default: false,
    },
    error: String,
  },
  computed: {
    inputText: {
      get() {
        return this.text;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    onEnterPressed(event) {
      this.$refs.inputRef.blur();
      this.$emit('enter', event);
    },
  },
};

